module.exports = __webpack_public_path__ + "static/media/benlux-x-ruban-rose.44a555b9.png";